import { Component, OnInit, Input, ViewChild, ElementRef, ViewEncapsulation, OnDestroy, AfterViewInit } from '@angular/core';
import { GlobalService } from 'app/global/global.service';
import { Subscription, delay, of, take } from 'rxjs';
import uuid from 'short-unique-id';
import { RoleDetail } from '../signing-page/signing-page.dto';
import { SignatureBoxService } from './signature-box.service';
import { Signature } from './signature-box.dto';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SigningHelperService } from '../signing-page/signing-page-helper';
import { TranslocoService } from '@jsverse/transloco';
@Component({
  selector: 'app-signature-box',
  templateUrl: './signature-box.component.html',
  styleUrls: ['./signature-box.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SignatureBoxComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() hasModal:boolean;
  @Input() roleDetail:RoleDetail;
  @Input() isEform:boolean;
  @ViewChild('regular_signaturepad') regular_signaturepad:ElementRef;
  public currectDate = new Date().toISOString();
  public uniqueid = new uuid({ length: 6, dictionary: 'number' });
  public penColors = [{color:'#0061ef',colorname:'blue'},{color:'#000',colorname:'black'},{color:'red',colorname:'red'}];
  public penColor = '#0061ef';
  public penColorIndex = 0;
  public uuid = this.uniqueid();
  public signatureType = 'draw';
  public nextFont = 0;
  public fontFamily = 'Montserrat';
  public selectedSignatureFontSize = '34';
  public timeOutSubscription: Subscription;
  public signatureImage: string = '';
  public imageChangedEvent: string = '';
  public croppedImage: string = '';
  public signatureSubmitted: boolean = false;
  public signatureValue: string = '';
  public signatureBG: string = '';
  public signatureloader: boolean = false;
  public signatureSubcription: Subscription;
  public base64Signature:string = '';
  constructor(
    private globalService: GlobalService,
    private signatureBoxService: SignatureBoxService,
    public activeModal: NgbActiveModal,
    private signingHelperService:SigningHelperService,
    private translocoService:TranslocoService
  ) { }

  public signatureFontSize = [
    { id: 1, name: '34' },
    { id: 2, name: '36' },
    { id: 3, name: '38' },
    { id: 4, name: '40' },
    { id: 5, name: '42' },
    { id: 6, name: '44' },
    { id: 7, name: '46' },
    { id: 8, name: '48' },
    { id: 9, name: '50' },
    { id: 10, name: '52' },
    { id: 11, name: '54' },
    { id: 12, name: '56' },
    { id: 13, name: '58' },
    { id: 14, name: '60' },
    { id: 15, name: '62' },
    { id: 16, name: '64' },
    { id: 17, name: '66' },
    { id: 18, name: '68' },
    { id: 19, name: '70' },
    { id: 20, name: '72' },
  ];

  ngOnInit(): void {
    this.signingHelperService.callFunction$.subscribe((res:{assignedSignatureBox:boolean}) => {
      if(res){
        const signature = res.assignedSignatureBox ? this.base64Signature : this.getSignature();
        this.signingHelperService.setSignature({signature:signature,signature_type:this.signatureType});
      }
    })
  }

  ngAfterViewInit(){
    setTimeout(() => {
      if(this.regular_signaturepad?.nativeElement){
        this.globalService.initializeSignature(this.regular_signaturepad?.nativeElement,this.uuid);
      }
    }, 1000);
  }

  changeColor(color,index){
    // Try to get the signature object safely
    const sigObj = this.globalService?.signatureObjects?.[this.uuid];
    if (!sigObj) {
      return;
    }
    this.globalService.signatureObjects[this.uuid].penColor = color.color;
    this.penColor = color.color;
    this.penColorIndex = index;
    if(this.signatureType == 'draw'){
      let penData = this.globalService.signatureObjects[this.uuid].toData();
      penData = penData.map(d => {
        d.penColor = color.color;
        return d;
      });
      this.globalService.signatureObjects[this.uuid].fromData(penData, { clear: false });
    }
  }

  clearSignature(){
    if(this.globalService.signatureObjects[this.uuid] != undefined){
      this.globalService.signatureObjects[this.uuid].clear();
      if(document.querySelector('.signature-type-box')){
        (document.querySelector('.signature-type-box') as HTMLInputElement).value = '';
      }
    }
  }

  allowedSelf(){
    return this;
  }

  changeSignatureType(type){
    this.signatureType = type.nextId;
    const that = this.allowedSelf();
    this.timeOutSubscription = of(null).
    pipe(
      delay(600),
      take(1)
    ).subscribe(() => {
      if(this.signatureType == 'draw'){
       that.globalService.initializeSignature(this.regular_signaturepad.nativeElement,that.uuid,[],that.penColor); 
      }
    });
  }

  changeNextFont(){
    this.nextFont++;
    if(this.nextFont >= this.globalService.fonts.length){
      this.nextFont = 0;
    }
    this.fontFamily = this.globalService.fonts[this.nextFont];
  }

  changeFontSize(){
    
  }

  /**
   * Create or update new signature
   * @returns Object
   */
  async addSignature() {
    const getSignature = this.getSignature();
    if(!getSignature){
      this.globalService.toastrWarning(this.translocoService.translate("Toaster warning message for signer (Signing page - section) - Signature is required"));
      return;  
    }
    this.signatureloader = true;
    this.signatureBoxService.saveSignature(getSignature, this.roleDetail.id, this.isEform, this.roleDetail.roleable_id).subscribe(
      {
        next: (signature:Signature) => {
          this.signatureloader = false;
          const signatureData = {...{base64signature:getSignature,signature_type:this.signatureType}, ...signature};
          this.activeModal.close({status:true, signature:signatureData});
        }
      }
    )
  }

  /**
   * get signature as a base64
   * @returns 
   */
  getSignature(){
    let signature = null;
    if (this.signatureType == 'draw' && (this.globalService.signatureObjects[this.uuid] != undefined && this.globalService.signatureObjects[this.uuid]._isEmpty == false)) {
      signature = this.globalService.signatureObjects[this.uuid].toDataURL();
    }
    else if (this.signatureType == 'type' && this.signatureValue != '') {
      signature = this.generateSignature();
    }
    else if (this.signatureType == 'upload' && this.imageChangedEvent != '') {
      signature = this.croppedImage ?? null;
    }
    if (signature == null || signature == '') {
      return;
    }
    this.base64Signature = signature;
    return signature;
  }

  /** Generate canvas behalf on text */
  generateSignature() {
    const name = this.signatureValue;
    let fontSize = 120;
    if (name.length > 6) {
      fontSize = fontSize - (name.length * 1.2);
    }
    const canvas = <HTMLCanvasElement>(document.getElementById("CustomSignCanvas"));
    canvas.width = canvas.getBoundingClientRect().width * 2;
    canvas.height = (canvas.getBoundingClientRect().height < 350 ? 350 : canvas.getBoundingClientRect().height);//canvas.getBoundingClientRect().height;
    const ctx = canvas.getContext("2d");
    const width = canvas.width;
    const height = canvas.height;
    const x = width / 2;
    const y = height / 2;
    ctx.clearRect(0, 0, width, height);
    ctx.font = fontSize + "pt " + this.fontFamily;
    ctx.fillStyle = String(this.penColor);
    ctx.textAlign = "center";
    ctx.textBaseline = 'middle';
    ctx.fillText(name, x, y);
    return canvas.toDataURL('image/png', 1);
  }

  closeModalAndClearSignature(){
    // this.globalService.signatureObjects[this.uuid].clear();
    this.activeModal.dismiss();
  }

  ngOnDestroy(){
    if(this.timeOutSubscription){
      this.timeOutSubscription.unsubscribe();
    }
  }

}
